import { UseQueryResult, useQuery } from 'react-query'
import request from '../../../request'
import { useDealership } from '../../../../store/zustand/dealershipStore'
import { useBuildQueryParams } from '../../../../lib/hooks/useBuildQueryParams'
import { SourceInsights } from '../../../../lib/types/SourceInsights'

type ResultType = {
  insights: SourceInsights
}

export const useGetCustomerSourceInsights = ({
  customer_source_id,
  filters,
}: {
  customer_source_id: string | number
  filters?: Record<string, unknown>
}): UseQueryResult<ResultType, Error> => {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters)
  return useQuery<ResultType, Error>(
    [
      'customers',
      'sources',
      'insights',
      dealership?.id,
      customer_source_id,
      { queryParams },
    ],
    ({ signal }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/sources/${customer_source_id}/insights`,
        method: 'GET',
        signal,
        params: {
          ...queryParams,
        },
      }),
    {
      enabled: !!customer_source_id,
    },
  )
}
